import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChecklistGroupComponent } from './components/checklist-group/checklist-group.component';
import { ChecklistItemComponent } from './components/checklist-item/checklist-item.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormsModule } from '@angular/forms';
import { DxScrollViewModule } from 'devextreme-angular';
import { TranslateModule } from '@ngx-translate/core';
import { ChecklistItemNoChildrenComponent } from './components/checklist-item-no-children/checklist-item-no-children.component';

@NgModule({
  declarations: [ChecklistGroupComponent, ChecklistItemComponent, ChecklistItemNoChildrenComponent],
  imports: [CommonModule, MatCheckboxModule, FormsModule, DxScrollViewModule, TranslateModule],
  exports: [ChecklistGroupComponent],
})
export class ChecklistGroupModule {}
